export default "__VITE_PUBLIC_ASSET__60cf9420__"